import React from "react";

const  HomePageImage = () =>  {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 888 485.489"
      className="homeImage"
    >
      <path
        fill="#6c63ff"
        d="M275.412 460.3h-28.419a3.768 3.768 0 00-3.767 3.768v12.474a3.768 3.768 0 003.767 3.768h4.71V499h19v-18.69h4.71a3.768 3.768 0 003.767-3.768v-12.474a3.768 3.768 0 00-3.768-3.768z"
        transform="translate(-156 -207.256)"
      ></path>
      <path
        fill="#3f3d56"
        d="M303.877 574.461a146.105 146.105 0 01-25.418-86.624 3.081 3.081 0 00-2.406-3.075v-5.39H246.04v5.315h-.413a3.08 3.08 0 00-3.067 3.308q3.546 49.442-23.954 88.677a8.487 8.487 0 00-1.536 5.143l3.282 101.519a8.788 8.788 0 008.713 8.481h67.887a8.791 8.791 0 008.718-8.631l1.265-98.566a17.789 17.789 0 00-3.057-10.157z"
        transform="translate(-156 -207.256)"
      ></path>
      <path
        d="M269.488 464.365a8.129 8.129 0 01-16.258 0"
        opacity="0.2"
        transform="translate(-156 -207.256)"
      ></path>
      <path
        fill="#6c63ff"
        d="M293.13 608.182h-8.22a21.576 21.576 0 00-42.65 0h-8.22a6.067 6.067 0 00-5.997 6.99l8.93 58.041h51.274l10.846-57.846a6.067 6.067 0 00-5.963-7.185z"
        transform="translate(-156 -207.256)"
      ></path>
      <path
        fill="#e6e6e6"
        d="M827.952 307.634L825.98 386.448 823.538 484.181 740.414 484.181 737.552 369.675 736 307.634 827.952 307.634z"
      ></path>
      <path
        fill="#6c63ff"
        d="M775.723 265.704H787.4929999999999V421.654H775.723z"
      ></path>
      <path
        fill="#3f3d56"
        d="M978.067 574.275l-2.226 112.02h-75.767l-2.608-131.243a51.634 51.634 0 0140.827 5.615c12.659 7.487 26.88 11.517 39.774 13.608z"
        transform="translate(-156 -207.256)"
      ></path>
      <path
        fill="#e6e6e6"
        d="M752.031 379.63H762.8309999999999V390.43H752.031z"
      ></path>
      <path
        fill="#e6e6e6"
        d="M759.387 357.562H770.1869999999999V368.362H759.387z"
      ></path>
      <path
        fill="#e6e6e6"
        d="M936.424 575.816H947.2239999999999V586.616H936.424z"
        transform="rotate(36.563 1177.509 241.48)"
      ></path>
      <path
        fill="#e6e6e6"
        d="M955.937 594.951H966.737V605.751H955.937z"
        transform="rotate(36.563 1197.022 260.615)"
      ></path>
      <path
        fill="#e6e6e6"
        d="M922.834 605.986H933.6339999999999V616.786H922.834z"
        transform="rotate(36.563 1163.919 271.649)"
      ></path>
      <circle cx="805.148" cy="351.035" r="2.207" fill="#3f3d56"></circle>
      <circle cx="760.275" cy="336.323" r="2.207" fill="#3f3d56"></circle>
      <circle cx="797.792" cy="320.875" r="2.207" fill="#3f3d56"></circle>
      <circle cx="444.508" cy="241.754" r="241.754" fill="#6c63ff"></circle>
      <path
        d="M600.508 625.467a176.456 176.456 0 11124.774-51.683 175.304 175.304 0 01-124.774 51.683zm0-342.032c-91.298 0-165.574 74.276-165.574 165.575 0 91.297 74.276 165.574 165.574 165.574 91.298 0 165.574-74.277 165.574-165.574 0-91.299-74.276-165.575-165.574-165.575z"
        opacity="0.2"
        transform="translate(-156 -207.256)"
      ></path>
      <circle cx="444.508" cy="241.754" r="171.016" fill="#3f3d56"></circle>
      <path
        fill="#ff6584"
        d="M473.327 380.627a21.704 21.704 0 1138.682-19.698l48.316 94.879a21.704 21.704 0 11-38.681 19.698z"
        transform="translate(-156 -207.256)"
      ></path>
      <path
        d="M478.717 391.21l-2.23-4.379c11.129-8.647 24.197-15.007 38.68-19.698l2.23 4.379c-15.675 3.264-29.01 9.305-38.68 19.698zM489.123 411.645l-2.23-4.379c11.13-8.647 24.198-15.007 38.681-19.698l2.23 4.38c-15.675 3.263-29.011 9.304-38.68 19.697zM499.53 432.08l-2.23-4.378c11.129-8.648 24.198-15.007 38.68-19.699l2.23 4.38c-15.675 3.264-29.01 9.305-38.68 19.698zM509.936 452.516l-2.23-4.379c11.13-8.647 24.198-15.007 38.681-19.698l2.23 4.379c-15.675 3.264-29.011 9.305-38.68 19.698zM520.343 472.951l-2.23-4.379c11.13-8.647 24.198-15.007 38.681-19.698l2.23 4.38c-15.675 3.263-29.011 9.304-38.681 19.697z"
        opacity="0.2"
        transform="translate(-156 -207.256)"
      ></path>
      <path
        fill="#ff6584"
        d="M437.08 416.146a21.704 21.704 0 1138.68-19.698l48.317 94.879a21.704 21.704 0 01-38.682 19.698z"
        transform="translate(-156 -207.256)"
      ></path>
      <path
        d="M442.468 426.729l-2.23-4.379c11.13-8.647 24.198-15.007 38.681-19.698l2.23 4.379c-15.675 3.264-29.011 9.305-38.68 19.698zM452.875 447.164l-2.23-4.379c11.129-8.647 24.198-15.007 38.681-19.698l2.23 4.38c-15.675 3.263-29.012 9.304-38.681 19.697zM463.281 467.6l-2.23-4.38c11.13-8.647 24.198-15.006 38.682-19.698l2.23 4.38c-15.676 3.264-29.012 9.305-38.682 19.698zM473.688 488.035l-2.23-4.379c11.13-8.647 24.198-15.007 38.681-19.698l2.23 4.379c-15.675 3.264-29.011 9.305-38.681 19.698zM484.095 508.47l-2.23-4.379c11.129-8.647 24.197-15.007 38.68-19.698l2.23 4.38c-15.675 3.263-29.01 9.304-38.68 19.697z"
        opacity="0.2"
        transform="translate(-156 -207.256)"
      ></path>
      <path
        fill="#e6e6e6"
        d="M714.778 454.45l.152.001a25.888 25.888 0 0024.24-16.236 84.503 84.503 0 005.923-31.694c-.272-45.91-37.623-83.575-83.53-84.21a84.744 84.744 0 00-35.277 162.32 25.667 25.667 0 0028.506-5.286 84.458 84.458 0 0159.986-24.894z"
        transform="translate(-156 -207.256)"
      ></path>
      <circle cx="515.246" cy="193.559" r="27.984" fill="#f9a825"></circle>
      <circle cx="454.426" cy="187.115" r="3.297" fill="#3f3d56"></circle>
      <circle cx="345.598" cy="190.225" r="3.297" fill="#3f3d56"></circle>
      <circle cx="471.996" cy="152.949" r="3.297" fill="#3f3d56"></circle>
      <circle cx="471.902" cy="247.973" r="3.297" fill="#3f3d56"></circle>
      <circle cx="537.199" cy="146.141" r="3.297" fill="#3f3d56"></circle>
      <circle cx="324.207" cy="236.313" r="3.297" fill="#3f3d56"></circle>
      <circle cx="348.305" cy="283.731" r="3.297" fill="#3f3d56"></circle>
      <circle cx="499.7" cy="289.949" r="12.438" fill="#ff6584"></circle>
      <path
        d="M665.028 497.982a9.328 9.328 0 01-18.657 0M646.371 496.428a9.328 9.328 0 0118.657 0"
        opacity="0.2"
        transform="translate(-156 -207.256)"
      ></path>
      <ellipse
        cx="495.035"
        cy="285.674"
        fill="#ff6584"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="499.7"
        cy="284.119"
        fill="#ff6584"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="499.7"
        cy="294.225"
        fill="#ff6584"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="504.364"
        cy="288.006"
        fill="#ff6584"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="503.586"
        cy="296.557"
        fill="#ff6584"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="494.258"
        cy="292.67"
        fill="#ff6584"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <circle cx="524.575" cy="256.524" r="12.438" fill="#ff6584"></circle>
      <path
        d="M689.903 464.556a9.328 9.328 0 01-18.657 0M671.246 463.002a9.328 9.328 0 0118.657 0"
        opacity="0.2"
        transform="translate(-156 -207.256)"
      ></path>
      <ellipse
        cx="519.91"
        cy="252.248"
        fill="#ff6584"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="524.575"
        cy="250.693"
        fill="#ff6584"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="524.575"
        cy="260.799"
        fill="#ff6584"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="529.239"
        cy="254.58"
        fill="#ff6584"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="528.461"
        cy="263.131"
        fill="#ff6584"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="519.133"
        cy="259.244"
        fill="#ff6584"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <circle cx="549.45" cy="273.625" r="12.438" fill="#6c63ff"></circle>
      <path
        d="M714.778 481.658a9.328 9.328 0 01-18.657 0M696.121 480.103a9.328 9.328 0 0118.657 0"
        opacity="0.2"
        transform="translate(-156 -207.256)"
      ></path>
      <ellipse
        cx="544.785"
        cy="269.35"
        fill="#6c63ff"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="549.45"
        cy="267.795"
        fill="#6c63ff"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="549.45"
        cy="277.901"
        fill="#6c63ff"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="554.114"
        cy="271.682"
        fill="#6c63ff"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="553.336"
        cy="280.233"
        fill="#6c63ff"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="544.008"
        cy="276.346"
        fill="#6c63ff"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <circle cx="487.262" cy="275.18" r="12.438" fill="#6c63ff"></circle>
      <path
        d="M652.59 483.213a9.328 9.328 0 01-18.656 0M633.934 481.658a9.328 9.328 0 0118.656 0"
        opacity="0.2"
        transform="translate(-156 -207.256)"
      ></path>
      <ellipse
        cx="482.598"
        cy="270.904"
        fill="#6c63ff"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="487.262"
        cy="269.35"
        fill="#6c63ff"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="487.262"
        cy="279.455"
        fill="#6c63ff"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="491.926"
        cy="273.236"
        fill="#6c63ff"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="491.149"
        cy="281.787"
        fill="#6c63ff"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="481.821"
        cy="277.901"
        fill="#6c63ff"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <circle cx="515.246" cy="280.621" r="12.438" fill="#6c63ff"></circle>
      <path
        d="M680.575 488.654a9.328 9.328 0 11-18.657 0M661.918 487.1a9.328 9.328 0 1118.657 0"
        opacity="0.2"
        transform="translate(-156 -207.256)"
      ></path>
      <ellipse
        cx="510.582"
        cy="276.346"
        fill="#6c63ff"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="515.246"
        cy="274.791"
        fill="#6c63ff"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="515.246"
        cy="284.897"
        fill="#6c63ff"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="519.91"
        cy="278.678"
        fill="#6c63ff"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="519.133"
        cy="287.229"
        fill="#6c63ff"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="509.805"
        cy="283.342"
        fill="#6c63ff"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <circle cx="534.68" cy="293.836" r="12.438" fill="#ff6584"></circle>
      <path
        d="M700.008 501.869a9.328 9.328 0 11-18.656 0M681.352 500.314a9.328 9.328 0 1118.656 0"
        opacity="0.2"
        transform="translate(-156 -207.256)"
      ></path>
      <ellipse
        cx="530.016"
        cy="289.561"
        fill="#ff6584"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="534.68"
        cy="288.006"
        fill="#ff6584"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="534.68"
        cy="298.111"
        fill="#ff6584"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="539.344"
        cy="291.893"
        fill="#ff6584"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="538.567"
        cy="300.443"
        fill="#ff6584"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <ellipse
        cx="529.239"
        cy="296.557"
        fill="#ff6584"
        rx="0.777"
        ry="1.166"
      ></ellipse>
      <circle cx="374.734" cy="246.418" r="3.297" fill="#3f3d56"></circle>
      <path
        fill="#f9a825"
        d="M464.345 366.08L385.17 344.123 388.203 332.857 467.378 354.815 464.345 366.08z"
      ></path>
      <path
        fill="#f9a825"
        d="M608.738 569.57a218.268 218.268 0 01-82.078 0v-11.678a250.991 250.991 0 0082.078 0zM617.176 534.536a218.268 218.268 0 01-82.078 0v-11.679a250.992 250.992 0 0082.078 0z"
        transform="translate(-156 -207.256)"
      ></path>
      <path
        fill="#f9a825"
        d="M645.558 548.55a218.268 218.268 0 01-82.078 0V536.87a250.992 250.992 0 0082.078 0z"
        transform="translate(-156 -207.256)"
      ></path>
      <path
        fill="#f9a825"
        d="M652.462 561.785a218.268 218.268 0 01-82.078 0v-11.678a250.992 250.992 0 0082.078 0z"
        transform="translate(-156 -207.256)"
      ></path>
      <path
        fill="#f9a825"
        d="M520.531 371.824L439.554 385.426 437.676 373.904 518.652 360.302 520.531 371.824z"
      ></path>
      <path
        fill="#f9a825"
        d="M664.435 580.577a219.97 219.97 0 01-74.58 34.784l-4.805-10.611a252.954 252.954 0 0074.58-34.785zM657.689 545.166a219.97 219.97 0 01-74.58 34.785l-4.805-10.612a252.954 252.954 0 0074.58-34.784z"
        transform="translate(-156 -207.256)"
      ></path>
      <path
        fill="#f9a825"
        d="M689.243 545.872a219.97 219.97 0 01-74.58 34.784l-4.804-10.611a252.955 252.955 0 0074.58-34.785z"
        transform="translate(-156 -207.256)"
      ></path>
      <path
        fill="#f9a825"
        d="M700.962 554.972a219.97 219.97 0 01-74.58 34.785l-4.805-10.612a252.954 252.954 0 0074.58-34.784z"
        transform="translate(-156 -207.256)"
      ></path>
      <path fill="#00bf71" d="M442.953 324.93H446.84V328.817H442.953z"></path>
      <path fill="#00bf71" d="M454.614 392.559H458.501V396.446H454.614z"></path>
      <path fill="#00bf71" d="M392.426 324.93H396.313V328.817H392.426z"></path>
      <path fill="#00bf71" d="M482.598 373.125H486.485V377.012H482.598z"></path>
      <path fill="#00bf71" d="M484.93 350.582H488.817V354.469H484.93z"></path>
      <path
        fill="#00bf71"
        d="M574.856 545.4H580.297V548.509H574.856z"
        transform="rotate(34.156 836.887 189.435)"
      ></path>
      <path
        fill="#00bf71"
        d="M620.719 553.951H626.1600000000001V557.0600000000001H620.719z"
        transform="rotate(34.156 882.75 197.986)"
      ></path>
      <path
        fill="#00bf71"
        d="M564.75 568.721H570.191V571.83H564.75z"
        transform="rotate(34.156 826.782 212.755)"
      ></path>
      <path
        fill="#00bf71"
        d="M596.621 565.611H602.062V568.72H596.621z"
        transform="rotate(124.156 576.261 422.2)"
      ></path>
      <path
        fill="#00bf71"
        d="M617.61 571.053H623.051V574.162H617.61z"
        transform="rotate(124.156 597.25 427.642)"
      ></path>
      <path
        fill="#00bf71"
        d="M673.578 552.396H679.019V555.505H673.578z"
        transform="scale(-1) rotate(-55.844 -771.723 1232.57)"
      ></path>
      <path fill="#3f3d56" d="M0 483.248H888V485.489H0z"></path>
    </svg>
  );
}

export default HomePageImage;
